import PropTypes from 'prop-types';

export const propTypes = {
  episode: PropTypes.object,
  onClickMenu: PropTypes.func,
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  isSortable: PropTypes.bool,
  hideDescription: PropTypes.bool,
  episodeKey: PropTypes.string,
  elementIdString: PropTypes.string,
  fixedFontSize: PropTypes.bool,
  loading: PropTypes.bool,
  hideTrackNumber: PropTypes.bool,
  disableTrackNumber: PropTypes.bool
};

export const defaultProps = {
  episode: null,
  onClickMenu: undefined,
  onClick: undefined,
  isPlaying: false,
  isSortable: false,
  hideDescription: false,
  episodeKey: null,
  elementIdString: null,
  fixedFontSize: false,
  loading: false,
  hideTrackNumber: false,
  disableTrackNumber: false
};